import http from "./http_common";

class NotificationService{
    queryString(payload) {
        return Object.keys(payload)
          .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
          .join("&");
      }
   NotificationGet(payload){
    const queryString = this.queryString(payload);
    return http.get(`notification/list/filter?${queryString}`);
   }
   NotificationCountGet(payload){
    const queryString = this.queryString(payload);
    return http.get(`/notification/getCountStatus?${queryString}`)
   }
   NotificationCountStatusPut(payload){
    return http.put(`/notification/countstatus/${payload.id}`,payload)
   }
}


export default new NotificationService()

